import ActionButton from '../../../../common/components/documentViewer/actionButton';
import { IActionButtonCommonProps } from '../../../../common/typings/DocumentViewer/actionButtonCommonProps';
import { commonTestIds } from '../../../../common/utils/commonTestIds';
import DialogCloseListener from '../../../../common/utils/dialogCloseListener';
import { executeIfLoggedIn } from '../../../../common/utils/logonUtils';
import RfeWebDialog from '../../../../common/utils/rfeWebDialog';
import { IOrderViewerMainStore } from '../../typing/stores';
import { NonAnonymousActions } from '../../utils/constants';
import { Icons } from 'copyright-clearance-center-common-ui';
import { inject } from 'mobx-react';
import { forwardRef } from 'react';

interface IRightsInfoButton {
	contentId?: number;
	itemType?: number;
	logonUrl?: string;
}

const RightsInfoButton: React.ForwardRefExoticComponent<
	IRightsInfoButton & IActionButtonCommonProps & React.HTMLProps<HTMLButtonElement>
> = forwardRef((props, ref) => {
	const navigateSummaryCloseHandler = (res: {
		op: string;
		crperm: boolean;
		contentId: number;
		docids: string;
		itemType: number;
	}) => {
		const params = new URLSearchParams();
		params.set('contentId', `${res.contentId}`);
		params.set('action', 'rights');
		if (res.itemType != undefined) {
			params.set('itemType', `${res.itemType}`);
		}

		if (res.docids != undefined) {
			params.set('docids', res.docids);
		}

		const backUrl = new URL(window.location.href);
		params.set('back', backUrl.toString());
		mainNavigateContent('order/rightssummary.aspx', params);
	};

	const orderContentCloseHandler = (res: {
		op: string;
		crperm: boolean;
		contentId: number;
		docids: string;
		itemType: number;
	}) => {
		if (res.crperm) {
			doCrPermission(res.contentId, res.docids);
		} else {
			doOrder(res.contentId, res.itemType);
		}
	};

	const doOrder = (contentId: number, itemType: number) => {
		const params = new URLSearchParams();
		params.set('contentId', `${contentId}`);
		if (params != undefined) {
			params.set('itemType', `${itemType}`);
		}

		mainNavigateContent('order/orderform.aspx?', params);
	};

	const doCrPermission = (contentId: number, docIds: string) => {
		const params = new URLSearchParams();
		params.set('contentId', `${contentId}`);
		params.set('action', 'rights');
		if (docIds) {
			params.set('docids', docIds);
		}

		mainNavigateContent('order/orderform.aspx', params);
	};

	const handler = () => {
		executeIfLoggedIn(
			() => {
				const params = new URLSearchParams();
				params.set('contentId', `${props.contentId}`);
				params.set('action', 'rights');
				params.set('itemType', `${props.itemType}`);
				DialogCloseListener.subscribe('navigateSummary', navigateSummaryCloseHandler);
				DialogCloseListener.subscribe('orderContent', orderContentCloseHandler);
				RfeWebDialog.show(`order/rightsinfodlg.aspx?${params}`);
			},
			props.logonUrl,
			NonAnonymousActions.RightsInfo
		);
	};

	return (
		<ActionButton
			label={localize('Rights info')}
			handler={handler}
			icon={Icons.CopyrightIcon}
			isPrimary={props.isPrimary}
			testId={commonTestIds.rightsInfoBtn}
			controlledBy={props.controlledBy}
			ref={ref}
			className={props.className}
		/>
	);
});

RightsInfoButton.displayName = 'RightsInfoButton';

export default inject((stores: IOrderViewerMainStore) => ({
	contentId: stores.orderViewerStore.viewModel.headerModel.contentId,
	itemType: stores.orderViewerStore.viewModel.headerModel.itemType,
	logonUrl: stores.orderViewerStore.viewModel.orderLogonViewerUrl.logonUrl
}))(RightsInfoButton);
